import React from "react";
import Wrapper from "../../../components/Wrapper/Wrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { COURSE_SOURCE_ANALYTICS_TABLE_HEAD as columns } from "../../../components/datagrid/CRM/Analytics/CourseSourceAnalytics/CourseSourceAnalyticsTableHead";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const data = [
    {
        serialNumber: 1,
        courseName: "Classroom - Long Term",
        totalLeads: 13360,
        admissionConfirmed: 1240,
        conversionPercentage: "30%",
        admissionCancelled: 22,
        pendingAdmissions: 46,
        assessmentPending: 2,
        notConnected: 2,
        notInterested: 3,
        alreadyAssessed: 1,
        notAttended: 0,
        admissionConfirmedBasedOnConfirmeddate: 656768,
    },
];

export default function CourseSourceAnalytics() {
    const [gridSize, setGridSize] = React.useState(5);
    const [value, setValue] = React.useState(null);
    return (
        <div>
            <Wrapper
                title="Course-Source Analytics"
                Content={
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: 2,
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From"
                                    value={value}
                                    openTo="year"
                                    views={["year", "month", "day"]}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To"
                                    value={value}
                                    openTo="year"
                                    views={["year", "month", "day"]}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: 2,
                            }}
                        >
                            <Box>
                                <GlobalSelectField
                                    options={{
                                        // formik: formik,
                                        label: "Lead Type",
                                        name: "courseId",
                                        sx: { width: "100%" },
                                        // data: data.coursesPreData,

                                        keys: {
                                            id: "courseId",
                                            value: "courseName",
                                        },
                                    }}
                                    variant="filled"
                                />
                            </Box>
                            <Box>
                                <GlobalSelectField
                                    options={{
                                        // formik: formik,
                                        label: "Source",
                                        name: "courseId",
                                        sx: { width: "100%" },
                                        // data: data.coursesPreData,

                                        keys: {
                                            id: "courseId",
                                            value: "courseName",
                                        },
                                    }}
                                    variant="filled"
                                />
                            </Box>
                        </Box>
                        <Paper elevation={3}>
                            <Box width="100%">
                                <Box
                                    sx={{
                                        backgroundColor: "grey.200",
                                        borderRadius: "8px 8px 0 0",
                                        display: "flex",
                                        height: 44,
                                    }}
                                ></Box>
                                <DataGrid
                                    components={{ Toolbar: CustomGridToolbar }}
                                    // loading={loading}
                                    rows={data}
                                    columns={columns}
                                    autoHeight
                                    getRowId={(row) => row.serialNumber}
                                    pageSize={gridSize}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    onPageSizeChange={(newGridSize) =>
                                        setGridSize(newGridSize)
                                    }
                                />
                            </Box>
                        </Paper>
                    </>
                }
            />
        </div>
    );
}
